<template>
    <div id="popup">
        <transition name="fade">
            <div v-show="showPanel" class="cover" @click="coverClick"></div>
        </transition>
        <transition name="slide">
            <div v-if="showPanel&&type=='bottom'" class="bottomPanel">
                <slot></slot>
            </div>
        </transition>
        <transition name="scale">
            <div v-if="showPanel&&type=='center'" class="centerPanel">
                <slot></slot>
            </div>
        </transition>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        props:{
            coverClose:{
                default:true,
                type:Boolean
            },
            type:{
                default:"bottom",
                type:String
            }
        },
        data() {
            return {
                showPanel:false
            }
        },
        created() {
        
        },
        methods: {
            show(){
                this.showPanel = true;
            },
            close(){
                this.showPanel = false;
            },
            coverClick(){
                if(this.coverClose){
                    this.$emit("close");
                    this.showPanel = false;
                }
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .cover{
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.6);
        top: 0;
        left: 0;
        z-index: 1500;
    }
    .bottomPanel{
        position: fixed;
        width: 100%;
        z-index: 1501;
        bottom: 0;
        left: 0;
        transition: all 0.3s;
    }
    .centerPanel{
        position: fixed;
        z-index: 1501;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    .slide-enter-active, .slide-leave-active {
        transition: all 0.3s;
    }
    .slide-enter, .slide-leave-to {
        transform: translateY(100%);
    }
    .scale-enter-active, .scale-leave-active {
        transition: all 0.3s;
    }
    .scale-enter, .scale-leave-to {
        transform: translate(-50%,-50%) scale(0.6);
        opacity: 0;
    }
</style>